module.exports = __webpack_public_path__ + "img/bz36.3275b8fc.png";